module.exports = __webpack_public_path__ + "static/media/work.8b81c143.svg";